export default {
    grayBackground: '#454545',
    darkBackground: '#151515',
    black: '#000000',
    white: '#ffffff',
    darkGrey: '#878787',
    mediumGreyOne: '#C6C6C6',
    mediumGreyTwho: '#D0D0D0',
    lightGrey: '#ECECEC',
    ktmFreerideEBlue: '#00A1E4',
    orangeGradientTop: '#FF6600',
    orangeGradientBottom: '#FF1500',
    ktmFreerideEBlueGradientTop: '#00BEEC',
    ktmFreerideEBlueGradientBottom: '#0082DB',
}